import MDTypography from "components/MDTypography";
import formatCurrency from "helpers/formatCurrency";
import moment from "moment";

export default function getPaymentHistoryTableData(payments) {
  const columns = [
    { Header: "Date", accessor: "date", align: "left" },
    { Header: "Name", accessor: "name", align: "left" },
    { Header: "Account", accessor: "account", align: "center" },
    { Header: "Authorized By", accessor: "authorizer", align: "left", minWidth: "90px" },
    { Header: "Reference", accessor: "reference", align: "left" },
    { Header: "Status", accessor: "status", align: "center" },
    { Header: "Amount", accessor: "amount", align: "right" },
  ];

  return {
    columns: columns,
    rows: payments.map((payment) => {
      return {
        date: (
          <MDTypography variant="caption" color="text" fontWeight="medium">
            {moment(payment.createdAt).format("YY/MM/DD")}
          </MDTypography>
        ),
        name: (
          <MDTypography variant="caption" color="text" fontWeight="medium">
            {payment.account.holder_name}
          </MDTypography>
        ),
        account: (
          <MDTypography variant="caption" color="text" fontWeight="medium">
            {payment.account.account_number}
          </MDTypography>
        ),
        authorizer: (
          <MDTypography variant="caption" color="text" fontWeight="medium">
            {payment.authorizer.name}
          </MDTypography>
        ),
        reference: (
          <MDTypography variant="caption" color="text" fontWeight="medium">
            {payment.reference}
          </MDTypography>
        ),
        status: (
          <MDTypography
            variant="caption"
            color={payment.settled ? "success" : "warning"}
            fontWeight="medium"
          >
            {payment.settled ? "Settled" : "Not Settled"}
          </MDTypography>
        ),
        amount: (
          <MDTypography variant="caption" color="text" fontWeight="medium">
            {formatCurrency(payment.amount)}
          </MDTypography>
        ),
      };
    }),
  };
}
